import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface Props {
  children?: ReactNode;
}

const TcWrapperSearchMap: FC<Props> = ({ children }) => {
  //state
  const fullScreen = useSelector((state: RootState) => state.setting.fullScreen);

  return (
    <div
      className={`absolute flex flex-col gap-2 transition-all duration-500 opacity-80 hover:opacity-100 right-4 top-4 ${fullScreen ? 'bottom-1/2 translate-y-1/2' : 'bottom-8 '}`}>
      {children}
    </div>
  );
};

export default TcWrapperSearchMap;
